import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String, method: String }
  static targets = ["confirmButton"]

  declare readonly urlValue: string
  declare readonly methodValue: string
  declare readonly confirmButtonTarget: HTMLButtonElement

  confirmDelete(event: Event) {
    event.preventDefault()

    const button = this.confirmButtonTarget
    const originalContent = button.innerHTML

    // Show loading state
    button.disabled = true
    button.innerHTML = `
      <span class="loading loading-spinner loading-sm"></span>
      Deleting...
    `

    // Get CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    // Submit the delete request
    fetch(this.urlValue, {
      method: this.methodValue || 'DELETE',
      headers: {
        'X-CSRF-Token': token || '',
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Delete failed')
      }
    }).then(html => {
      // Close the modal
      const modal = document.getElementById('api_key_delete_modal') as HTMLDialogElement
      if (modal) {
        modal.close()
      }

      if (html) {
        // Parse the turbo stream to find the target for animation
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const removeAction = doc.querySelector('turbo-stream[action="remove"]')
        const targetId = removeAction?.getAttribute('target')

        if (targetId) {
          const apiKeyRow = document.getElementById(targetId)

          if (apiKeyRow) {
            // Add exit animation class
            apiKeyRow.classList.add('api-key-item-exit')

            // Wait for animation to complete, then let Turbo process the stream
            apiKeyRow.addEventListener('animationend', () => {
              // Now let Turbo process all stream actions (remove + potential update for empty state)
              Turbo.renderStreamMessage(html)
            }, { once: true })
          } else {
            // Element not found, just process the stream
            Turbo.renderStreamMessage(html)
          }
        } else {
          // No remove action, just process the stream
          Turbo.renderStreamMessage(html)
        }
      }

      // Reset button state
      button.disabled = false
      button.innerHTML = originalContent
    }).catch(error => {
      console.error('Error deleting API key:', error)
      button.disabled = false
      button.innerHTML = originalContent
      alert('Failed to delete API key. Please try again.')
    })
  }
}
